var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"information",class:{ hidden: _vm.hidden }},[_c('a',{staticClass:"information-toggle",attrs:{"href":"javascript:;"},on:{"click":function($event){$event.preventDefault();return _vm.onClickInformation.apply(null, arguments)}}},[_vm._v("Information")]),_vm._v(" "),(_vm.showContent)?_c('div',{staticClass:"information-content",domProps:{"innerHTML":_vm._s(_vm.page.text)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30802f4b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Information.vue
// module id = 45
// module chunks = 0